/**
 *
 * @param {Number} date1 Date in timestamp
 * @param {Number} data2 Date in timestamp
 * @returns Difference between date1 to data2 in years
 */
export const diffInYears = (date1: number, data2: number): number =>
  Math.floor((date1 - data2) / 1000 / (60 * 60 * 24) / 365.25);

export const getAge = (date: string | number | Date) => {
  const birthDate = new Date(date).getTime();
  const now = Date.now();

  if (date === null) return null;

  return diffInYears(now, birthDate);
};

export const formatToUSDate = (date: string | number | Date) => {
  const newDate = new Date(date);

  const year = newDate.getUTCFullYear();
  const month = twoDigit(newDate.getUTCMonth() + 1);
  const day = twoDigit(newDate.getUTCDate());

  return `${month}/${day}/${year}`;
};

export const formatToShortDate = (date: string | number | Date) => {
  const newDate = new Date(date);

  const year = newDate.getFullYear();
  const month = twoDigit(newDate.getMonth() + 1);
  const day = twoDigit(newDate.getDate());

  return `${month}/${day}/${year}`;
};

const twoDigit = (num: number) => ("0" + num).slice(-2);

export const addDays = (date: string | number | Date, days: number): string | number | Date => {
  const oldDate = new Date(date);
  oldDate.setDate(oldDate.getDate() + days);

  return oldDate;
};

export const isISODate = (dateString: string) => {
  const dateISORegex = /^\d{4}-\d{2}-\d{2}$/;
  // Matches YYYY-MM-DD (ISO)
  return dateISORegex.test(dateString);
};

export const isUSDate = (dateString: string) => {
  const dateUSRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  // Matches MM/DD/YYYY (US)
  return dateUSRegex.test(dateString);
};

export const convertUSToISODate = (dateString: string) => {
  // Convert from MM/DD/YYYY (US) to YYYY-MM-DD (ISO)
  const [month, day, year] = dateString.split("/");
  if (month && day && year) {
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  return "";
};

export const convertISOToUSDate = (dateString: string) => {
  // Convert from YYYY-MM-DD (ISO) to MM/DD/YYYY (US)
  const [year, month, day] = dateString.split("-");
  return `${month}/${day}/${year}`;
};

export const normalizeDate = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

// Helper to format date from yyyy-mm-dd to mm/dd/yyyy
export const formatDateMMDDYYYY = (dateString?: string): string => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  if (!year || !month || !day) return "";
  return `${month}/${day}/${year}`;
};

//Helper to get today's date in ISO format (YYYY-MM-DD)
export const getTodayISODate = (): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today.toISOString().split("T")[0];
};

// Function to format all ISO date values in an object
export const formatDatesInObject = (initialValues: Record<string, any>): Record<string, any> => {
  const isISODate = (val: string) => typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val);

  const formatted: Record<string, any> = {};

  Object.entries(initialValues).forEach(([key, value]) => {
    if (isISODate(value)) {
      formatted[key] = formatDateMMDDYYYY(value);
    } else {
      formatted[key] = value;
    }
  });

  return formatted;
};
